import React from 'react';
import { ArrowRight, MessageCircle } from 'lucide-react';
import { contactInfo } from '../mock';

const Hero = () => {
  const handleWhatsApp = () => {
    const message = encodeURIComponent("Hi! I'm interested in your services. Please provide more information.");
    window.open(`https://wa.me/${contactInfo.whatsapp}?text=${message}`, '_blank');
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="min-h-screen flex items-center justify-center relative overflow-hidden pt-24 pb-16 px-4"
      style={{ background: 'var(--gradient-hero)' }}
    >
      <div className="max-w-4xl mx-auto text-center z-10">
        {/* Headline */}
        <h1 className="heading-1 mb-6">
          Launch Your Online Business & Get Customers with High-Converting Websites and Ads
        </h1>

        {/* Subheadline */}
        <p className="body-large mb-8" style={{ color: 'var(--text-secondary)' }}>
          Froma Web helps beginners and small businesses grow online using smart websites and paid ads.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button onClick={scrollToContact} className="btn-primary w-full sm:w-auto">
            Get Free Consultation
            <ArrowRight className="ml-2" size={20} />
          </button>
          <button onClick={handleWhatsApp} className="btn-secondary w-full sm:w-auto">
            <MessageCircle className="mr-2" size={20} />
            WhatsApp Now
          </button>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 grid grid-cols-3 gap-8 max-w-2xl mx-auto">
          <div className="text-center">
            <div className="heading-2" style={{ color: 'var(--accent-text)' }}>
              100+
            </div>
            <p className="body-medium mt-2" style={{ color: 'var(--text-secondary)' }}>
              Projects Completed
            </p>
          </div>
          <div className="text-center">
            <div className="heading-2" style={{ color: 'var(--accent-text)' }}>
              50+
            </div>
            <p className="body-medium mt-2" style={{ color: 'var(--text-secondary)' }}>
              Happy Clients
            </p>
          </div>
          <div className="text-center">
            <div className="heading-2" style={{ color: 'var(--accent-text)' }}>
              5+
            </div>
            <p className="body-medium mt-2" style={{ color: 'var(--text-secondary)' }}>
              Years Experience
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
